import { render, staticRenderFns } from "./SimpleTextRow.vue?vue&type=template&id=10f6a840&"
import script from "./SimpleTextRow.vue?vue&type=script&lang=js&"
export * from "./SimpleTextRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports